import type { CandidateRegistration, CandidateSubmissionResponse } from '@/types/candidate';
import { config } from '@/config/env';

export const candidateService = {
  // Enviar registro de candidato
  async submitCandidateRegistration(data: CandidateRegistration): Promise<CandidateSubmissionResponse> {
    try {
      // El jobRequestId va en la URL del endpoint, no en el body
      if (!data.jobRequestId) {
        throw new Error('ID de solicitud requerido');
      }

      // Preparar datos como JSON (con la URL del CV si existe)
      const jsonData = {
        fullName: data.fullName,
        phone: data.phone,
        email: data.email,
        age: data.age, // number
        profesion: data.profesion,
        experienceYears: data.experienceYears, // number
        certificaciones: data.certificaciones,
        residenceCity: data.residenceCity,
        salaryExpectation: data.salaryExpectation,
        experienceDescription: data.experienceDescription,
        privacyConsent: data.privacyConsent, // boolean
        cvUrl: data.cvUrl, // URL del CV en S3
        // Origen declarado (RH-06). Se omiten si no se capturaron: el
        // ValidationPipe del backend corre con forbidNonWhitelisted, pero
        // mandar `undefined` en JSON equivale a no mandar la llave.
        sourceId: data.sourceId,
        referredByText: data.referredByText?.trim() || undefined,
      };

      const response = await fetch(`${config.apiBaseUrl}/candidates/apply/${data.jobRequestId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Error al enviar el registro');
      }

      const result = await response.json();
      return {
        success: true,
        message: result.message || 'Registro enviado exitosamente',
        candidateId: result.candidateId,
      };
    } catch (error) {
      console.error('Error submitting candidate registration:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Error desconocido al enviar el registro',
      };
    }
  },

  // Obtener información de una vacante (para mostrar en el formulario)
  async getJobRequestInfo(publicToken: string) {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/public/job-requests/access/${encodeURIComponent(publicToken)}`
      );
      
      if (!response.ok) {
        throw new Error('No se pudo obtener la información de la vacante');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching job request info:', error);
      return null;
    }
  },
};
